import React from "react";
import { ResumeComponent } from "../commons/resume";
import colleges from "./colleges";

const Education = () => (
  <div>
    {colleges.map((college, index) => (
      <ResumeComponent
        key={index}
        period={college.period}
        title={college.title}
        subtitle={college.subtitle}
        description={college.description}
      />
    ))}
  </div>
);

export default Education;
